module.exports = {
	noneUrl: 'url이 존재하지 않습니다.',
	noneId: 'ID를 입력해주세요.',
	nonePWD: '암호를 입력해주세요.'
};


//////////////////
// WEBPACK FOOTER
// ./src/environments/errMsg.js
// module id = 525db2f50ff7ba7951d9
// module chunks = app/app.config app/common/service/http.service app/common/service/message.service app/views/SCR0001/SCR0001.controller